import { Transaction } from '../../models/transactions.model';
import { BillingStatus, RegStatus, ShiftState } from '../retail-places/retail-paces.types';

export type DeregisterReasonCode = string;
export type DeregisterReasonLocalizedMessage = string;
export type DeregisterReasons = Record<DeregisterReasonCode, DeregisterReasonLocalizedMessage>;
/*
DeregisterReasons example
0xFFFF0000000A: "Исключение ККМ из государственного реестра"
0xFFFF0000000B: "Иные случаи, не противоречащие НК РК"
0xFFFF0000000D: "Замена ККМ"
0xFFFF0000000E: "Кража, утеря ККМ"
0xFFFF00000007: "Прекращение осуществления деятельности, связанной с денежными расчетами"
0xFFFF00000008: "Регистрация ККМ в другом районе"
0xFFFF00000009: "Техническая неисправность ККМ"
*/

export interface ITotalCount {
  activatedCount: number;
  totalCount: number;
  billingStatusCounts?: IBillingStatusCount[];
  regStatusCounts?: IRegStatusCount[];
  shiftStateCounts?: IShiftStatusCount[];
}

export interface KkmDeregisterReason {
  [key: string]: string;
}

interface IBillingStatusCount {
  id: BillingStatus;
  count: number;
}

interface IRegStatusCount {
  id: RegStatus;
  count: number;
}

interface IShiftStatusCount {
  id: ShiftState;
  count: number;
}

export interface FilterKkmsRequest extends KkmsFilterState, KkmsPaginationState {
  sortField?: 'kkmCount' | 'title' | 'updatedAt';
  sortingDirection?: 'asc' | 'desc';
  type: KkmType;
}

export interface RetailPlacesWithKkmsRequest extends FilterKkmsRequest{
  criteria?: string;
}

export enum KkmType {
  Stationary = 0,
  Mobile = 1,
  Terminal = 2,
  Web = 3,
  UnknownType = -1,
}

export interface KkmsFilterState {
  billingStatuses: BillingStatus[];
  regStatuses: RegStatus[];
  shiftState: ShiftState;
}

export interface KkmsPaginationState {
  pagination: {
    from: number;
    to: number;
  };
}
export interface KkmAvailableOperations {
  availableOperations: AvailableOperationsModel;
}

export interface AvailableOperationsModel {
  registerKkm: boolean;
  reRegisterKkm: boolean;
  deregisterKkm: boolean;
  changeOfd: boolean;
  selectTariff: boolean;
  changeTariff: boolean;
  activateTariff: boolean;
  toggleRenewal: boolean;
  getToken: boolean;
}
// Данные не из swagger, а из запросов и шаблонов
// Все поля опциональны и не имеют более точных типов потому что описание интерфейса в свагере полностью не соответствует возвращаемым данным
export interface SearchTicketResponse {
  fiscalId?: string;
  id?: any;
  kkmId?: string;
  payments?: unknown[];
  shiftNumber?: number;
  transactionDate?: any;
  transactionDescription?: string;
  transactionType?: any;
}

export interface TransactionsResponse {
  pagination: {
    totalItems: number;
    pageSize: number;
  };
  transactions: Transaction[];
}

export interface Report {
  cash: number;
  id: string;
  nonNullableSums: {
    sells: number;
    sellReturns: number;
    buy: number;
    buyReturns: number;
    nonNullableSum: number;
  };
  revenue: number;
  shiftNumber: number;
  ticketCount: {
    sells: number;
    sellReturns: number;
    buys: number;
    buyReturns: number;
    total: number;
  };
  transactionDate: string;
  type: 0 | 1;
}

export interface BaseKkmFields { // KKM id
  kkmId: string; // Название ккм в ЛК
  kkmInternalName: string; // Модель ккм
  kkmModel: string; // Серийный/заводской номер ккм
  kkmSerialNumber: string; // Id торговой точки
  retailPlaceId: string; // название торговой точки
  retailPlaceTitle: string;
}
